import { Injectable } from "@angular/core";
import { ClareHomeRPCMethodNames, ClareHomeRPCServiceNames, HISTORY_METHODS } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy/equator-proxy.service";

@Injectable({
    providedIn: "root",
})
export class EquatorHistoryService {
    constructor(private readonly equatorProxyService: EquatorProxyService) {}

    /**
     * get event logs
     *
     * @param uuid
     * @param params
     * @returns
     */
    getServiceEventLog(uuid: string, params: any[]) {
        return this.call(uuid, HISTORY_METHODS.GET_SERVICE_EVENTS, params);
    }

    /**
     * There will be one of these in each equator-*.service class.
     * It supplies the JSON-RPC service name to the proxy.
     * Use this method in each method below.
     *
     * @param uuid
     * @param method
     * @param params
     * @param service
     * @returns
     */
    private call(uuid: string, method: ClareHomeRPCMethodNames, params: any[], service?: ClareHomeRPCServiceNames) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            service || ClareHomeRPCServiceNames.EVENT_HISTORY_QUERY, // service
            method, // method
            params // params
        );
    }
}
